
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3333 2C6.33333 2 2 3.08333 2 5.33333C2 7.58333 6.33333 8.66667 10.3333 8.66667C14.3333 8.66667 18.6667 7.58333 18.6667 5.33333C18.6667 3.08333 14.3333 2 10.3333 2ZM2 8.33331C3.91667 9.74998 7.16667 10.3333 10.3333 10.3333C13.5 10.3333 16.75 9.74998 18.6667 8.33331V11.1044C18.2882 11.0358 17.8983 11 17.5 11C14.679 11 12.2778 12.797 11.3786 15.3088C11.0297 15.3252 10.6803 15.3333 10.3333 15.3333C6.33333 15.3333 2 14.25 2 12V8.33331ZM11.0197 16.9908C10.7908 16.997 10.5618 17 10.3333 17C7.16667 17 3.91667 16.4167 2 15V18.6667C2 20.9167 6.33333 22 10.3333 22C11.1185 22 11.9164 21.9583 12.692 21.8742C11.6408 20.7194 11 19.1845 11 17.5C11 17.3286 11.0066 17.1588 11.0197 16.9908Z"></path><path d="M18.8767 13.0593C17.8424 13.0593 16.8622 13.4096 16.0697 14.0517L14.9481 13L14.6855 16.0821L17.7758 15.6505L16.67 14.617C17.3027 14.1363 18.0684 13.8721 18.8767 13.8721C20.8936 13.8721 22.5342 15.5127 22.5342 17.5297C22.5342 19.5466 20.8936 21.1872 18.8767 21.1872C18.5085 21.1872 18.1549 21.1271 17.8193 21.0255C17.6937 21.2847 17.525 21.5192 17.3202 21.7176C17.805 21.8992 18.3289 22 18.8767 22C21.3415 22 23.347 19.9944 23.347 17.5297C23.347 15.0649 21.3415 13.0593 18.8767 13.0593Z"></path><path d="M15.6256 21.5937C14.7291 21.5937 14 20.8646 14 19.9681C14 19.0716 14.7291 18.3425 15.6256 18.3425C16.5221 18.3425 17.2512 19.0716 17.2512 19.9681C17.2512 20.8646 16.5221 21.5937 15.6256 21.5937Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowrefreshdataFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
